import React from 'react';
import { GBTypography } from '@leapfinance/geebee-component-library';
import classNames from 'classnames';
import DeleteWarningIcon from '../../icons/DeleteWarningIcon';
var SectionDetailsChip = function (_a) {
    var chipLabel = _a.chipLabel, chipPosition = _a.chipPosition, variant = _a.variant;
    return (React.createElement("div", { className: classNames('lfc-absolute', chipPosition) },
        React.createElement("div", { className: 'lfc-w-fit lfc-rounded lfc-border lfc-border-gbTokens-error-300 lfc-bg-gbTokens-error-200 lfc-px-1 lfc-flex lfc-items-center lfc-gap-x-1 lfc-py-1' },
            React.createElement(DeleteWarningIcon, null),
            React.createElement(GBTypography, { variant: "caption2Semibold", className: "".concat(variant === 'error' ? ' lfc-text-gbTokens-error-700' : '') }, chipLabel))));
};
export default SectionDetailsChip;
//# sourceMappingURL=SectionDetailsChip.js.map